import { render, staticRenderFns } from "./OwnerTableRow.vue?vue&type=template&id=4581a4d7"
import script from "./OwnerTableRow.vue?vue&type=script&lang=js"
export * from "./OwnerTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports